import { Capacitor } from "@capacitor/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { Grid, Container, Typography, Button } from "@mui/material";
import { LANDING } from "../../../locales/namespaces";
import ApplyOnlineButton from "../../elements/ApplyOnlineButton";
import heroImage from "../../../../assets/images/landing/hero.png";
import logo from "../../../../assets/images/landing/logo.png";
import AuthBackground from "../../../../theme/mantis/assets/images/auth/authBackground";
import styles from "./hero.module.css";
import { getRouteUrl } from "../../../../helpers/getRouteUrl";

import { Link, useHistory } from "react-router-dom";
import { ROUTE_PAGE_CALCULATIONS_INDEX } from "../../../../modules/calculations/routes/routes";

import { ROUTE_PAGE_UNAUTHORIZED_CALCULATION } from "../../../../../src/routers/routes"

import { ROUTE_PAGE_WIZARD, ROUTE_PAGE_LOGIN } from "../../../../routers/routes";
const Hero = () => {
  const { t } = useTranslation(LANDING);

  return (

      <Grid container sx={{ height: '100%', minHeight: '100vh', flexDirection: 'column !important'}} >
        <Grid item xs={12} sm={Capacitor.isNativePlatform() ? 12 : 6} md={6}
          sx={{ height: { xs: "248px", sm: Capacitor.isNativePlatform() ? '248px' : "100%", md:  Capacitor.isNativePlatform() ? '248px' : "100%" }, position: 'relative', minHeight: { xs: "20px", sm: Capacitor.isNativePlatform() ? '248px' : "20px", md: Capacitor.isNativePlatform() ? '248px' : "20px"}, maxHeight: '33vh', overflow:'hidden'}}
          className="flex-center bg-color-mobile-top"
        >
          <AuthBackground />
          <img src={heroImage} alt="IMS" className={styles.imagemobile} />
        </Grid>

        <Grid item xs={12} sm={Capacitor.isNativePlatform() ? 12 : 6} md={6} className="flex-center" sx={{ flexDirection: 'column', padding: '0 24px', margin:'auto' }}>
          <img src={logo} alt="logo" style={{ marginTop: '6vh' }} />


          <Typography
            variant="h1"
            className="p-xl text-center"
            sx={{
              marginTop: '8px',
            }}
          >
              {t("You can now start your mortgage application online!")}

          </Typography>

          <Button
            disableElevation
            fullWidth
            sx={{ p: '14px 0', maxWidth: '500px', marginTop: '5vh' }}
            size={"small"}
            variant={"contained"}
            to={getRouteUrl(ROUTE_PAGE_WIZARD)}
            component={Link}
          >
              {t('Apply Now')}
      
          </Button>

          <Button
            disableElevation
            fullWidth
            sx={{ p: '14px 0', marginTop: '10px', maxWidth: '500px' }}
            size={"small"}
            variant={"text"}
            to={getRouteUrl(ROUTE_PAGE_LOGIN)}
            component={Link}
          >
            {t('Log In')}
          </Button>

          <Button
            disableElevation
            fullWidth
            sx={{ p: '14px 0', marginTop: '4vh', maxWidth: '500px' }}
            size={"small"}
            variant={"outlined"}
            to={getRouteUrl(ROUTE_PAGE_UNAUTHORIZED_CALCULATION)}
            component={Link}
          >
            {t('Calculation of mortgage installment')}
          </Button>
          <Button
            disableElevation
            fullWidth
            sx={{ p: '14px 0', marginTop: '10px', maxWidth: '500px' }}
            size="small"
            variant="outlined"
            onClick={() => window.open('https://ims-fc.gr/', '_blank')}
          >
            {t('Learn more about IMS Company')}
          </Button>

          <div style={{ marginTop: "3.8vh", marginBottom: "3.8vh" }}  className="elfsight-app-d669d24a-87f9-4a4c-9a12-3706b73cee49 mobile-login-google" data-elfsight-app-lazy />


        </Grid>

      </Grid>
  )
}

export default Hero;
